import React, { useEffect, useState } from 'react';
import { API_URLS } from '../apiUrl';
import axiosInstance from '../components/axiosInstance';

const BoroughEdit = ({ isOpen, closeModal, muniCipalityName, muniCipalityId, boroughName, boroughId }: any) => {

    const [boroughNames, setBoroughNames] = useState<string>("");
    const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
    const [formStatus, setFormStatus] = useState<{ type: string; message: string } | null>(null);

    useEffect(() => {
        if (boroughName) {
            setBoroughNames(boroughName);
        }
    }, [boroughName]);

    // Validate form
    const validateForm = () => {
        let valid = true;
        const newErrors: { [key: string]: string } = {};


        if (boroughNames.trim().length === 0) {
            newErrors["borough_names"] = "Borough name is required.";
            valid = false;
        }

        else if (!/^[A-Za-z0-9\s]+$/.test(boroughNames.trim())) {
            newErrors["borough_names"] = "Only text, numbers, and spaces are allowed.";
            valid = false;
        }


        setFormErrors(newErrors);
        return valid;
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setBoroughNames(event.target.value);
    };


    // Handle form submission
    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        if (!validateForm()) {
            return;
        }


        try {
            const response = await axiosInstance.put(`${API_URLS.BoroughUpdate}`, {
                borough_name: boroughNames.trim(),
                municipalityTbl_id: muniCipalityId,
                boroughTbl_id: boroughId
            });

            if (response.data.message) {
                setFormStatus({ type: "success", message: `Boroughs updated successfully` });
            }

            setTimeout(() => {
                setFormStatus(null);
                closeModal();
            }, 5000);

        } catch (error: any) {
            setFormStatus({
                type: "exists",
                message: "Duplicate entry found. Please check the data.",
            });
            setTimeout(() => {
                setFormStatus(null);
                closeModal();
            }, 5000);
        }
    };

    // If modal is not open, return null
    if (!isOpen) return null;

    const handleOutsideClick = (e: any) => {
        if (e.target === e.currentTarget) {
            closeModal();
        }
    };

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center" onClick={handleOutsideClick}>
            <div className="bg-white p-6 rounded-lg shadow-lg w-[740px] relative" onClick={(e) => e.stopPropagation()}>
                <h2 className="text-xl font-semibold mb-4">Edit Borough</h2>

                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
                        <div>
                            <label htmlFor="municipalityTbl_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Municipality <span className="text-red-600">*</span>
                            </label>
                            <input
                                type="text"
                                value={muniCipalityName}
                                id="municipalityTbl_id"
                                name="municipalityTbl_id"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                disabled
                            />
                        </div>

                        <div className="lg:col-span-2 sm:col-span-2">
                            <label htmlFor="borough_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white leading-3">
                                Borough <span className="text-red-600">*</span>
                            </label>

                            <div className="flex flex-wrap gap-2">
                                <input
                                    type="text"
                                    value={boroughNames}
                                    onChange={handleInputChange}
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Enter borough names separated by commas"
                                />
                                {formErrors.borough_names && (
                                    <div className="text-red-500 text-sm mt-2">{formErrors.borough_names}</div>
                                )}
                            </div>
                        </div>

                        <div className="lg:col-span-2 sm:col-span-2 mt-3">
                            <div className="flex gap-x-2">
                                <button
                                    type="submit"
                                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:opacity-50"
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

                {formStatus && (
                    <div
                        className={`mt-4 p-4 rounded-lg flex justify-between items-center ${formStatus.type === "success"
                            ? "bg-green-600 text-white"
                            : formStatus.type === "exists"
                                ? "bg-yellow-600 text-white"
                                : "bg-red-600 text-white"
                            }`}
                    >
                        <span>{formStatus.message}</span>
                        <button
                            className="ml-4 text-white font-bold text-lg focus:outline-none"
                            onClick={() => setFormStatus(null)}
                        >
                            &times;
                        </button>
                    </div>
                )}

            
                <button
                    onClick={closeModal}
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                >
                    <i className="ri-close-line"></i>
                </button>
            </div>
        </div>
    );
};

export default BoroughEdit;
